export default {
  NATIVE_DATA: "NATIVE_DATA",
  BRIDGE_TIMEOUT_ERR: "Timeout! Unable to get Native Data",
  PRINT: "PRINT",
  PRINT_RAW: "PRINT_RAW",
  WEIGH_SCALE: "WEIGH_SCALE",
  BACK_BUTTON: "BACK_BUTTON",
  USB_DEVICE_LIST: "USB_DEVICE_LIST",
  BLE_DEVICE_LIST: "BLE_DEVICE_LIST",
  SUNMI: "SUNMI",
  GET_DEVICES_WEIGH_SCALE: "GET_DEVICES_WEIGH_SCALE",
  GET_WEIGHT_WEIGH_SCALE: "GET_WEIGHT_WEIGH_SCALE",
  PLAY_SOUND: "PLAY_SOUND",
  FETCH: "FETCH",
  IP_VERIFY: "IP_VERIFY",
  CHECK: "CHECK",
  PING: "PING",
  FCM_TOKEN: "FCM_TOKEN",
};
